"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PercentageOfHighAndSignificantHighRisk = void 0;
const Field_type_1 = require("../../../types/Field.type");
const RiskyMerchantsRange_1 = require("../../enm/RiskyMerchantsRange");
exports.PercentageOfHighAndSignificantHighRisk = {
    priority: 1,
    label: 'fields.enm.risky_merchants_range.label',
    fallbackLabel: 'According to your merchant risk scoring model, what share of merchants are currently risk rated \'high\' or \'significantly high\'?',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['mor_group_answers.has_risk_classification', 'contract_onboarding_type'],
    type: Field_type_1.FieldType.Enum,
    options: RiskyMerchantsRange_1.RiskyMerchantsRangeRef.options,
    trackFieldValueWithAnalytics: true,
};
function isMandatory(payload, path) {
    return payload.mor_group_answers?.has_risk_classification === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return payload.mor_group_answers?.has_risk_classification === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
